import AdminText from './AdminText';

export default AdminText;
